import {
    SET_QRCODE_OBJECT,
    SET_VIDEO_URL,
    SET_CUSTOM_HTML,
    SET_CUSTOM_JS,
    RAISE_QRCODE_ERROR,
    CLEAR_ERROR
} from "./mutation-types";
import { QrcodeState } from "./state";

export default {
    [SET_QRCODE_OBJECT](state: QrcodeState, qrcodeObject) {
        state.qrcodeObject = { ...qrcodeObject };

        // compute logoB64
        if (state.qrcodeObject?.logoB64?.length) {
            if (state.qrcodeObject.logoB64.substr(0, 10) !== "data:image") {
                state.logoB64 = "data:image/png;base64," + state.qrcodeObject.logoB64;
            } else {
                state.logoB64 = state.qrcodeObject.logoB64;
            }
        }
    },

    [SET_VIDEO_URL](state: QrcodeState, videoUrl: string) {
        state.videoUrl = videoUrl;
    },

    [SET_CUSTOM_HTML](state: QrcodeState, customHtml: string) {
        state.customHtml = customHtml;
    },

    [SET_CUSTOM_JS](state: QrcodeState, customJs: string[]) {
        state.customJs = [].concat(customJs);
    },

    [RAISE_QRCODE_ERROR](state: QrcodeState, content: { title: string; text: string }) {
        state.error = { ...content };
    },

    [CLEAR_ERROR](state: QrcodeState) {
        state.error = {
            title: "",
            text: ""
        };
    }
};
